import { showNotification, showModal, hideModal } from '../utils.js';
import AuthService from '../services/auth.js';

export default class ProfileView {
    constructor() {
        this.mainContent = document.getElementById('main-content');
        this.currentUser = null;
    }

    async mount() {
        try {
            this.currentUser = AuthService.getCurrentUser();
            this.render();
            this.attachEventListeners();
        } catch (error) {
            showNotification(error.message, 'error');
        }
    }

    render() {
        const template = `
            <div class="max-w-3xl mx-auto">
                <div class="bg-white shadow overflow-hidden rounded-lg">
                    <div class="px-4 py-5 sm:px-6 bg-gray-50">
                        <h3 class="text-lg leading-6 font-medium text-gray-900">Информация профиля</h3>
                        <p class="mt-1 text-sm text-gray-500">Управляйте своей личной информацией и настройками.</p>
                    </div>
                    <div class="border-t border-gray-200">
                        <form id="profile-form" class="divide-y divide-gray-200">
                            <div class="px-4 py-5 space-y-6 sm:p-6">
                                <!-- Email field -->
                                <div>
                                    <label for="email" class="block text-sm font-medium text-gray-700">Адрес электронной почты</label>
                                    <div class="mt-1 relative rounded-md shadow-sm">
                                        <input type="email" name="email" id="email"
                                            class="p-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                            value="${this.currentUser.email}"
                                            disabled>
                                    </div>
                                    <p class="mt-2 text-sm text-gray-500">Адрес электронной почты не может быть изменен</p>
                                </div>

                                <!-- Username field -->
                                <div>
                                    <label for="username" class="block text-sm font-medium text-gray-700">Имя пользователя</label>
                                    <div class="mt-1">
                                        <input type="text" name="username" id="username"
                                            class="p-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                            value="${this.currentUser.username}"
                                            required>
                                    </div>
                                </div>

                                <!-- Phone field -->
                                <div>
                                    <label for="phone" class="block text-sm font-medium text-gray-700">Номер телефона</label>
                                    <div class="mt-1">
                                        <input type="tel" name="phone" id="phone"
                                            class="p-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                            value="${this.currentUser.phone}"
                                            required>
                                    </div>
                                </div>

                                <!-- Change Password Section -->
                                <div class="pt-6">
                                    <h4 class="text-md font-medium text-gray-900 mb-4">Сменить пароль</h4>
                                    <div class="space-y-4">
                                        <div>
                                            <label for="current-password" class="block text-sm font-medium text-gray-700">Текущий пароль</label>
                                            <div class="mt-1">
                                                <input type="password" name="currentPassword" id="current-password"
                                                    class="p-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                                    placeholder="Введите текущий пароль">
                                            </div>
                                        </div>
                                        <div>
                                            <label for="new-password" class="block text-sm font-medium text-gray-700">Новый пароль</label>
                                            <div class="mt-1">
                                                <input type="password" name="newPassword" id="new-password"
                                                    class="p-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                                    placeholder="Введите новый пароль">
                                            </div>
                                        </div>
                                        <div>
                                            <label for="confirm-password" class="block text-sm font-medium text-gray-700">Подтвердите новый пароль</label>
                                            <div class="mt-1">
                                                <input type="password" name="confirmPassword" id="confirm-password"
                                                    class="p-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                                    placeholder="Подтвердите новый пароль">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
                                <button type="submit"
                                    class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                                    Сохранить изменения
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        `;

        this.mainContent.innerHTML = template;
    }

    attachEventListeners() {
        const form = document.getElementById('profile-form');
        form.addEventListener('submit', async (e) => {
            e.preventDefault();

            const formData = new FormData(form);
            const userData = {
                username: formData.get('username'),
                phone: formData.get('phone')
            };

            const currentPassword = formData.get('currentPassword');
            const newPassword = formData.get('newPassword');
            const confirmPassword = formData.get('confirmPassword');

            try {
                // Handle password change separately if password fields are filled
                if (currentPassword && newPassword && confirmPassword) {
                    if (newPassword !== confirmPassword) {
                        showNotification('Новые пароли не совпадают', 'error');
                        return;
                    }
                    await AuthService.changePassword(currentPassword, newPassword);
                    showNotification('Пароль успешно изменен', 'success');
                }

                // Update other profile fields
                await AuthService.updateProfile(userData);
                showNotification('Профиль успешно обновлен', 'success');
                // Update current user data
                this.currentUser = AuthService.getCurrentUser();
            } catch (error) {
                showNotification(error.message, 'error');
            }
        });
    }
}
